import { render, staticRenderFns } from "./ConferenceWidget.vue?vue&type=template&id=17dd9cff"
import script from "./ConferenceWidget.vue?vue&type=script&lang=js"
export * from "./ConferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./ConferenceWidget.vue?vue&type=style&index=0&id=17dd9cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports